/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinesource1Inputs */

const en_refinesource1 = /** @type {(inputs: Refinesource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source image`)
};

const de_refinesource1 = /** @type {(inputs: Refinesource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellbild`)
};

/**
* | output |
* | --- |
* | "Source image" |
*
* @param {Refinesource1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinesource1 = /** @type {((inputs?: Refinesource1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinesource1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinesource1(inputs)
	return de_refinesource1(inputs)
});
export { refinesource1 as "refineSource" }